// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3OABH","options":"AnswerScale_options__3UOt_","selected":"AnswerScale_selected__8Pco4"};